module.exports = __webpack_public_path__ + "assets/TangentDetailed.ce17dd7d5d96e67225bcf2b627ac10fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TangentDetailed.png
// module id = 584
// module chunks = 0